/*
 * @Description: api
 * @Author: pliybird
 * @Date: 2023-06-15 13:06:39
 * @LastEditTime: 2023-06-28 11:04:12
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
import qs from "qs"
import instance from './request';

const api = {
    login: '/connect/token',
    slideShowList: '/api/slide/getlist', // 首页轮播图
    casesList: '/api/cases/getlist', // 案例列表
    newsList: '/api/news/getlist', // 新闻列表
    newsDetail: '/api/news/get', // 新闻详情
    casesDetail: '/api/cases/get', // 案例详情

    optionData: '/api/option/getoptionvalue', // 选项集
    busCreate: '/api/bus/create', // 新建业务咨询

    // 白皮书
    paperList: '/api/paper/getlist', // 白皮书列表
    paperCode: '/api/oauth/getcode', // 获取手机号码的验证码
    paperDownload: '/api/paper/getfile', // 下载白皮书

}



/**
 * @description: 白皮书列表
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function paperList(parameter) {
    return instance({
        url: `${api.paperList}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description:  获取手机号码的验证码
 * @param {*} parameter
 * @param {*} method POST
 * @return {*}
 */
export function paperCode(parameter) {
    return instance({
        url: `${api.paperCode}?${parameter}`,
        method: 'POST'
    })
}
/**
* @description: 下载白皮书
* @param {*} parameter
* @param {*} method GET
* @return {*}
*/
export function paperDownload(parameter) {
    return instance({
        url: `${api.paperDownload}?${parameter}`,
        method: 'GET',
        responseType: 'blob'
    })
}

/**
 * @description: 获取选项集
 * @param {*} parameter code标识
 * @param {*} method GET
 * @return {*}
 */
export function getOptions(parameter) {
    return instance({
        url: `${api.optionData}?code=${parameter}`,
        method: 'GET',
    })
}

/**
 * @description:  新建业务咨询
 * @param {*} parameter
 * @param {*} method POST
 * @return {*}
 */
export function createBus(parameter) {
    return instance({
        url: api.busCreate,
        method: 'POST',
        data: parameter
    })
}

/**
 * @description: 获取首页轮播图
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function slideShowList(parameter) {
    return instance({
        url: `${api.slideShowList}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description: 获取案例列表
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function casesList(parameter) {
    return instance({
        url: `${api.casesList}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description: 获取新闻列表
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function newsList(parameter) {
    return instance({
        url: `${api.newsList}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description: 获取新闻详情
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function newsDetail(parameter) {
    return instance({
        url: `${api.newsDetail}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description: 获取案例详情
 * @param {*} parameter
 * @param {*} method GET
 * @return {*}
 */
export function casesDetail(parameter) {
    return instance({
        url: `${api.casesDetail}?${parameter}`,
        method: 'GET',
    })
}

/**
 * @description: 登录接口
 * @param {*} parameter 登录参数
 * @param {*} method POST
 * @return {*}
 */
export function login(parameter) {
    return instance({
        url: api.login,
        method: 'POST',
        data: qs.stringify(parameter),
        baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_AUTH_URL : ''
    })
}